<template>
  <div
    class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50"
  >
    <div class="bg-white p-6 rounded-xl shadow-lg max-w-md w-full">
      <p class="text-lg mb-4" v-html="message"></p>
      <div class="flex items-center">
        <input
          type="checkbox"
          id="disclaimer-checkbox"
          v-model="checked"
          class="mr-2"
        />
        <label for="disclaimer-checkbox">{{
          $t('recommendation-confirmation')
        }}</label>
      </div>
      <div class="mt-4 flex justify-center">
        <button
          @click="closeModal"
          :disabled="!checked"
          class="px-4 py-2 text-black bg-primary hover:bg-secondary hover:text-white rounded-md disabled:bg-gray-300 disabled:text-black disabled:pointer-events-none"
        >
          {{ $t('close') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    message: String,
  },
  data() {
    return {
      checked: false,
    };
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
:deep(a) {
  color: #2563eb; /* blue-600 */
  text-decoration: underline;
  cursor: pointer;
}

:deep(a:hover) {
  color: #1d4ed8; /* blue-700 */
}
</style>
